import { useState } from 'react'
import { localPoint } from '@visx/event'

import { useStyles } from './forest-hover-line.style'

export const ForestHoverLine = function ({ dimensions, leftAxisWidth, bottomAxisHeight }) {
  const classes = useStyles()

  const [hoverLineX, setHoverLineX] = useState()
  const { width, height } = dimensions

  function onAxisHover (event) {
    if (!event.target || !event.target.ownerSVGElement) return

    const { x } = localPoint(event)
    setHoverLineX(x - leftAxisWidth)
  }

  return (
    <>
      { hoverLineX !== undefined && (
        <line
          className={classes.hoverLine}
          y1={0}
          y2={height}
          x1={hoverLineX}
          x2={hoverLineX}
        />
      )}
      <rect
        x={0}
        y={height}
        width={width}
        height={bottomAxisHeight}
        fill="transparent"
        onMouseMove={onAxisHover}
        onMouseLeave={() => { setHoverLineX() }}
      />
    </>
  )
}
